import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/Common/ProtectedRoute';
import Login from './components/Login/Login';
import DealerDashboard from './components/Dashboard/DealerDashboard';
import CorporateDashboard from './components/Dashboard/CorporateDashboard';
import DistrictManagerDashboard from './components/Dashboard/DistrictManagerDashboard';
import RegionalManagerDashboard from './components/Dashboard/RegionalManagerDashboard';
import AdminDashboard from './components/Dashboard/AdminDashboard';
import './App.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="App">
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            
            {/* Protected routes */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DealerDashboard />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/corporate"
              element={
                <ProtectedRoute requireCorporate>
                  <CorporateDashboard />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/district"
              element={
                <ProtectedRoute>
                  <DistrictManagerDashboard />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/regional"
              element={
                <ProtectedRoute>
                  <RegionalManagerDashboard />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />

            {/* Default redirect */}
            <Route path="/" element={<Navigate to="/login" replace />} />
          </Routes>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
